export const orderHeaders = {
  orderNo: {
    name: "Order No",
    width: 0.25,
  },
  docNumbers: {
    name: "Doc Numbers",
    width: 0.25,
  },
  organizationName: {
    name: "Organization",
    width: 0.4,
  },
  createdByEmail: {
    name: "Created By",
    width: 0.4,
  },
  requestType: {
    name: "Request Type",
    width: 0.3,
  },
  orderStatus: {
    name: "Status",
    width: 0.25,
    textAlign: "center",
    justifyContent: "center",
  },
  createdAt: {
    name: "Created At",
    width: 0.35,
  },
};

export const mdorderHeaders = {
  orderNo: {
    name: "Order No",
    width: 0.3,
  },
  docNumbers: {
    name: "Doc Numbers",
    width: 0.25,
  },
  organizationName: {
    name: "Organization",
    width: 0.5,
  },
  orderStatus: {
    name: "Status",
    width: 0.3,
    textAlign: "center",
  },
  createdAt: {
    name: "Created At",
    width: 0.4,
  },
};

export const smorderHeaders = {
  orderNo: {
    name: "Order No",
    width: 0.25,
  },
  docNumbers: {
    name: "Doc Numbers",
    width: 0.5,
  },
  orderStatus: {
    name: "Status",
    width: 0.3,
    textAlign: "right",
  },
};
